import { Close } from "@mui/icons-material";
import { Box, Drawer, IconButton } from "@mui/material";
import React from "react";
import Loader from "../Loader/Loader";

export const FormDrawer = ({
	children,
	open,
	setEditOpen,
	loading = false,
}) => {
	return (
		<Drawer anchor="right" open={open} onClose={() => setEditOpen(false)}>
			<Box
				sx={{
					width: 600,
					padding: 1,
					height: "100vh",
					overflowY: "scroll",
				}}
			>
				{loading && <Loader />}
				<IconButton
					style={{ position: "fixed" }}
					onClick={() => setEditOpen(false)}
				>
					<Close />
				</IconButton>
				{children}
			</Box>
		</Drawer>
	);
};
